import React, { useMemo } from 'react';
import { Box, FieldTypes, Inscription } from '@common-fe/common-fe';

import { FieldStateKey, PermissionKey } from '@/common/constants';
import { AllowRenewalsTypes, EmployerDto } from '@/modules/employer/types';
import useGetPermissionToEditOverridableField from '@/modules/user/hooks/useGetPermissionToEditOverridableField';

interface Props {
  viewMode?: boolean;
  formattedData?: EmployerDto;
}

const usePlansRenewalFields = ({ viewMode, formattedData }: Props) => {
  const allowRenewals = useMemo(() => formattedData?.overridableProperties?.allowRenewals, [formattedData]);

  const allowRenewalsPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.ALLOW_RENEWALS,
    FieldStateKey.ALLOW_RENEWALS
  );

  const fields = useMemo(() => [
    {
      name: 'allowRenewals',
      type: FieldTypes.Radio,
      label: (
        <Box flex={{ grow: 1 }}>
          <Inscription margin={{ bottom: '4px' }} weight="bold" color="textBody">
            Allow organization self-renew their plans
          </Inscription>
          <Box>
            <Inscription weight={500} color="textSecondary" size="small" lineHeight='18px'>
              Partner administrators can renew employer plans independently of this configuration
            </Inscription>
          </Box>
        </Box>
      ),
      disabled: viewMode,
      defaultValue: allowRenewals,
      options: [
        {
          label: 'No employer renewals',
          value: AllowRenewalsTypes.NO_RENEWALS,
        },
        // {
        //   label: 'Yes, allow full setup',
        //   value: AllowRenewalsTypes.FULL_SETUP,
        // },
        {
          label: 'Yes, allow but notify',
          value: AllowRenewalsTypes.BY_REQUEST,
        },
      ],
      ...allowRenewalsPermProps,
    },
  ], [viewMode, allowRenewals, allowRenewalsPermProps]);

  return fields;
};

export default usePlansRenewalFields;
